import type { DiaryCategory, DiaryPrompt } from "@couples/shared";

import { supabase } from "../supabase";

interface PromptRow {
  id: string;
  category: DiaryCategory;
  body: string;
}

function toPrompt(row: PromptRow): DiaryPrompt {
  return { id: row.id, category: row.category, body: row.body };
}

/** お題の全件。共通のマスタデータなので couple では絞り込まない */
export async function fetchPrompts(): Promise<DiaryPrompt[]> {
  const { data, error } = await supabase
    .from("diary_prompts")
    .select("id, category, body")
    .order("category")
    .order("sort_order");
  if (error) throw error;
  const rows: PromptRow[] = data;
  return rows.map(toPrompt);
}
